import { useEffect, useState, useContext } from "react";
import UploadDocumentsHospitalPersona from "./UploadDocumentsHospitalPersona";
import ReUploadDocumentsHospitalPersona from "./ReUploadDocumentsHospitalPersona";
import ImagesGalleryHospitalPersona from "../imageGallery/ImageGalleryHospitalPersona";
import ApprovedIcon from "../../assets/approvedIcon.svg";
import InreviewIcon from "../../assets/inreviewIcon.svg";
import ReuploadIcon from "../../assets/reuploadIcon.svg";
import { CircularProgressbarWithChildren } from "react-circular-progressbar";
import { docUploadRefreshContext } from "../../dashboard/cases/contexts/CaseContexts";
import DocumentStatusRing from "./DocumentStatusRing";
const DocumentDetail = ({
  document,
  getDate,
  step,
  isCurrentEnhancement = false,
}) => {
  const [isGalleryOpen, setGalleryOpen] = useState(-1);
  const [progresssiveTime, setProgressiveTime] = useState(0);
  const referenceContext = useContext(docUploadRefreshContext);
  const isFutureStage =
    (step <= 2 && document.documentType !== "ADMISSIONDOCUMENT") ||
    (step > 2 &&
      step <= 4 &&
      document.documentType === "ONDISCHARGEDOCUMENT") ||
    (step > 2 &&
      step <= 4 &&
      document.documentType.toUpperCase().includes("ENHANCEMENT") &&
      !isCurrentEnhancement);

  const progressiveCounter = () => {
    const updatedAt = new Date(document.updatedAt);
    const now = new Date();

    const diffInSeconds = Math.floor((now - updatedAt) / 1000);
    const totalMinutes = Math.floor(diffInSeconds / 60);

    const days = Math.floor(totalMinutes / (60 * 24));
    const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
    const minutes = totalMinutes % 60;

    let display = "";

    if (days > 0) {
      display += `${days}d`;
      if (hours > 0) display += ` ${hours}hr`;
      if (minutes > 0) display += ` ${minutes}m`;
    } else if (hours > 0) {
      display += `${hours}hr`;
      if (minutes > 0) display += ` ${minutes}m`;
    } else {
      display = `${minutes}m`;
    }

    setProgressiveTime(display);
  };
  const getRejectedCount = () => {
    if (document.completeDocRejected) {
      return "Complete";
    }
    const filteredData = document?.documenturlmasters?.filter(
      (document) => document.status?.toLowerCase() === "rejected",
    );
    return filteredData?.length > 0
      ? filteredData.length + " Document Rejected"
      : "Add New Document";
  };

  const getDocumentsData = () => {
    referenceContext.getMappedDocuments();
  };
  useEffect(() => {
    progressiveCounter();

    const intervalId = setInterval(progressiveCounter, 1000);

    return () => clearInterval(intervalId);
  }, [document?.updatedAt]);
  return (
    <div
      style={{
        background: document?.status?.toLowerCase().includes("approved")
          ? "linear-gradient(90deg, #FFFFFF 2%, #B4FFCF 18.5%, #B4FFCF 81%, #FFFFFF 98%)"
          : document?.status?.toLowerCase().includes("rejected")
            ? "linear-gradient(90deg, #FFFFFF 2%, #FFA1A1 18.5%, #FEA2A2 81%, #FFFFFF 98%)"
            : document?.status?.toLowerCase().includes("inreview")
              ? "linear-gradient(90deg, #FFFFFF 2%, #EDFF8C 18.5%, #EDFF8C 81%, #FFFFFF 98%)"
              : "linear-gradient(90deg, #FFFFFF 2%, #D9D9D9 18.5%, #D9D9D9 81%, #FFFFFF 98%)",
      }}
      className="flex items-center text-[#1B1B1B] text-[12px] 2xl:text-sm font-medium  leading-[18px] -tracking-[3%] py-2 first:mt-0 mt-2"
    >
      <div className="w-[55%] font-normal pl-2">{document?.documentName}</div>

      <div className="w-[20%]"></div>
      {/* <div className="w-[20%] flex justify-end items-center uppercase px-4">
        {document?.status?.toLowerCase() === "rejected" ? (
          <div>{getRejectedCount()}</div>
        ) : document?.documenturlmasters?.length > 0 ? (
          <div>Pages:{document?.documenturlmasters?.length}</div>
        ) : (
          ""
        )}
      </div> */}
      <div className="w-[10%] animate-pulse text-[#444] font-semibold">
        {!document?.status?.toLowerCase().includes("approved") &&
          progresssiveTime}
      </div>
      <div
        className={` w-[5%] uppercase ${
          document?.status?.toLowerCase().includes("approved")
            ? "text-[#4AB571]"
            : document?.status?.toLowerCase().includes("rejected")
              ? "text-[#B53030]"
              : "text-[#0B0B0B]"
        }`}
      >
        {document?.status}
      </div>
      <div className="w-[10%] flex justify-center">
        {document?.status?.toLowerCase().includes("approved") ? (
          <div className="flex items-center gap-2 ">
            <img src={ApprovedIcon} alt="approved-icon" />{" "}
            <div className="group relative">
              <img
                src={InreviewIcon}
                alt="in-review-icon"
                onClick={() => setGalleryOpen(true)}
                className="cursor-pointer"
              />
              {document.totalUnreadComments > 0 && (
                <div className="w-[16px] h-[16px] text-xs text-center  absolute -top-2  -right-1 text-white bg-[#ff0000] rounded-full">
                  {document?.totalUnreadComments}
                </div>
              )}
              <div className="absolute -bottom-6 -left-3 group-hover:block hidden text-[10px] text-white bg-[#191919] p-1 rounded-[4px] ">
                Review
              </div>
            </div>
            {/* <div className="group relative">
              <UploadDocumentsHospitalPersona
                documentDetails={document}
                sequencePrev={document?.documenturlmasters?.length}
                type="add extra"
              />
              <div className="absolute -bottom-6 -left-3 group-hover:block hidden text-[10px] text-white text-nowrap bg-[#191919] p-1 rounded-[4px] ">
                Upload More
              </div>
            </div> */}
          </div>
        ) : document?.status?.toLowerCase().includes("inreview") ? (
          <div className="flex items-center gap-2 ">
            <div className="group relative">
              <img
                src={InreviewIcon}
                alt="in-review-icon"
                onClick={() => setGalleryOpen(true)}
                className="cursor-pointer"
              />
              {document.totalUnreadComments > 0 && (
                <div className="w-[16px] h-[16px] text-xs text-center  absolute -top-2  -right-1 text-white bg-[#ff0000] rounded-full">
                  {document?.totalUnreadComments}
                </div>
              )}
              <div className="absolute -bottom-6 -left-3 group-hover:block hidden text-[10px] text-white bg-[#191919] p-1 rounded-[4px] ">
                Review
              </div>
            </div>
            <div className="group relative">
              <UploadDocumentsHospitalPersona
                documentDetails={document}
                sequencePrev={document?.documenturlmasters?.length}
                type="add extra"
              />
              <div className="absolute -bottom-6 -left-3 group-hover:block hidden text-[10px] text-white text-nowrap bg-[#191919] p-1 rounded-[4px] ">
                Upload More
              </div>
            </div>
          </div>
        ) : document?.status?.toLowerCase().includes("rejected") ? (
          <div className="flex items-center gap-1">
            {!isFutureStage && (
              <ReUploadDocumentsHospitalPersona documentDetails={document} />
            )}
            <div className="group relative flex items-center">
              <img
                src={InreviewIcon}
                alt="in-review-icon"
                onClick={() => setGalleryOpen(true)}
                className="cursor-pointer"
              />
              {document.totalUnreadComments > 0 && (
                <div className="w-[16px] h-[16px] text-xs text-center  absolute -top-2  -right-1 text-white bg-[#ff0000] rounded-full">
                  {document?.totalUnreadComments}
                </div>
              )}
              <div className="absolute -bottom-7 left-0 group-hover:block hidden text-[10px] text-white bg-[#191919] p-1 rounded-[4px] z-[20]">
                Review
              </div>
            </div>
          </div>
        ) : (
          <div className="group relative">
            {!isFutureStage && (
              <UploadDocumentsHospitalPersona documentDetails={document} />
            )}{" "}
            <div className="absolute -bottom-6 -left-3 group-hover:block hidden text-[10px] text-white bg-[#191919] p-1 rounded-[4px] z-[20]">
              Upload
            </div>
          </div>
        )}
      </div>
      {isGalleryOpen >= 0 && (
        <ImagesGalleryHospitalPersona
          data={document?.documenturlmasters}
          setOpen={setGalleryOpen}
          view={true}
          type={"document"}
          getDocumentsData={getDocumentsData}
          documentId={document?.id}
        />
      )}
    </div>
  );
};

export default DocumentDetail;
